import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

@Component({
  selector: 'hh-button',
  templateUrl: './hh-button.component.html',
  styleUrls: ['./hh-button.component.css']
})
export class HhButtonComponent implements OnDestroy {

  loadingCheck = false;
  @Input() title
  @Output() clickLisnt = new EventEmitter<boolean>();
  @Input() loading: Subject<boolean>
  loadingSub: Subscription


  constructor() {

    // this.test.emit("testing")

  }


  save(): void {
    this.loadingCheck = true;
    this.clickLisnt.emit(true)
    this.loadingSub = this.loading.subscribe(d => {
      this.loadingCheck = !d;
    });
  }

  ngOnDestroy(): void {
    if (this.loadingSub)
      this.loadingSub.unsubscribe()
  }

}
